import { AuthService } from "../authentication/auth.service";
import { ApiConfig } from "../api-config/api-config";
import { FeaturesSupportedConfig } from "./features-supported";

export class FeaturesSupportedService {

  public static canOverrideFeaturesSupported(auth: AuthService): boolean {
    return auth.isSuperAdmin() || FeaturesSupportedConfig.canGetFromLocalStorage();
  }

  public static overrideFeaturesSupported(auth: AuthService, features: string[]): void {
    if (!this.canOverrideFeaturesSupported(auth)) return;
    this.setSupportedFeatures(features);
  }

  public static resetFeaturesSupported(auth: AuthService): void {
    if (!this.canOverrideFeaturesSupported(auth)) return;
    this.setSupportedFeatures(this.getAllFilterableFeatures());
    FeaturesSupportedConfig.resetLocalStorageFeatures();
  }

  public static getAllFilterableFeatures(): string[] {
    return FeaturesSupportedConfig.allFeatures();
  }

  public static getFeatures(): { feature: string, enabled: boolean }[] {
    return this.getAllFilterableFeatures().map(f => ({
      feature: f,
      enabled: this.isFeatureSupported(f),
    }));
  }

  public static isFeatureSupported(feature: string): boolean {
    const features = ApiConfig.getFeaturesSupported();
    return features.includes(feature);
  }

  // overrides the supported feature set for the rest of the day
  private static setSupportedFeatures(features: string[]): void {
    ApiConfig.overrideSupportedFeatures(features);
    FeaturesSupportedConfig.setLocalStorageFeatures(features);
  }
}